import React, { Component } from 'react';
import { Modal } from 'antd';
import { store } from 'Store/store.index';
import { isMobile } from 'Utils/device';
import { getUserInfo } from 'Api/fwApi/login';
import utils from '@foxit/utils';
// import { collaborationService } from '@/store/services/index';
export default class FwSaveModal extends Component {
  constructor(props) {
    super(props);
  }
  switch = () => {
    let Events = window.UIExtension.PDFViewCtrl.Events;
    window.pdfui.eventEmitter.emit(Events.openFileFailed, null);
    // store.appStore.backToHomeStart('normal');
    store.saveFileNewStore.setShowSaveDialog(false);
    const origin = location.origin;
    const redirectUrl = encodeURIComponent(`${origin}/login.html`);
    const cb = encodeURIComponent(window.location.href);
    const IAMSwitchUrl = `https://account.foxitreader.cn/switch?accountId=${store.loginNewStore.sharSwitchAccountId}&redirectUrl=${redirectUrl}&cb=${cb}`;
    store.loginNewStore.setIAMSwitchUrl(IAMSwitchUrl);
    store.loginNewStore.setIsShowIframeSso(true);
    store.shareCollaborationStore.setShareUserType('');
  };
  onOk = async () => {
    const config = {
      headers: {
        client: 'editCloud',
      },
      params: {
        token: utils.util.getQueryString('token'),
      },
    };
    try {
      const res = await getUserInfo(config);
      if (res.ret === 0) {
        if (res.data.identity !== 'vip') {
          store.common.getIsShowOpenMember(true);
          return;
        }
      }
    } catch (error) {
      throw error;
    }
    store.saveFileNewStore.saveFile('downFile');
    this.switch();
  };
  onCancelShow = () => {
    store.saveFileNewStore.setShowSaveDialog(false);
    this.switch();
  };

  render() {
    const msg = this.props;
    return (
      <React.Fragment>
        <div>
          {!isMobile && (
            <Modal
              visible={msg.visible}
              className="common-dialog ant-alert-modal subscriptionMember"
              title="福昕云编辑"
              onCancel={this.onCancelShow}
              okText="保存"
              cancelText="放弃"
              onOk={this.onOk}>
              <div>是否保存文件</div>
            </Modal>
          )}
        </div>
      </React.Fragment>
    );
  }
}
